import { Divider, Spin } from 'antd';
import React, { useEffect } from 'react';
import MainInfo from './MainInfo';
import ApproveInfo from './ApproveInfo';
import {
  IApprovalListPortfolio,
  IPortfolio,
} from 'interface/portfolio.interface';
import PortfolioApi from 'apis/PortfolioApi';
import { STATUS } from 'constants/reponseStatus';
import { useMutation, useQuery } from 'react-query';
import handleError401 from 'utils/handleError401';
import { IResponseT } from 'interface/base.interface';

interface IProps {
  portfolio?: IPortfolio;
}
export default function Info(props?: IProps): JSX.Element {
  const portfolio = props?.portfolio;
  const [approvalInfo, setApprovalInfo] =
    React.useState<IApprovalListPortfolio>();
  const { isLoading: isLoading } = useQuery(
    ['getApprovalDetail', portfolio],
    () => {
      if (portfolio) {
        const pof_code = portfolio.pof_code;
        return PortfolioApi.getApprovalDetail(pof_code);
      }
    },
    {
      onSuccess: (response: any) => {
        if (response?.status === STATUS.SUCCESS) {
          setApprovalInfo(response.data);
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  return (
    <Spin spinning={isLoading}>
      <MainInfo portfolio={portfolio} />
      <Divider dashed />
      <div
        className="text-primary-50"
        style={{ fontSize: '18px', fontWeight: 'bold' }}
      >
        Thông tin phê duyệt
      </div>
      <ApproveInfo
        info={1}
        approvalInfo={approvalInfo?.stage_1_PhatHanhDanhMuc}
      />
      <ApproveInfo
        info={2}
        approvalInfo={approvalInfo?.stage_2_ChiNhanhDKMau}
      />
      <ApproveInfo
        info={3}
        subInfo={1}
        approvalInfo={approvalInfo?.stage_3_DKGioHang_ChiNhanh}
      />
      <ApproveInfo
        info={undefined}
        subInfo={2}
        approvalInfo={approvalInfo?.stage_4_DKGioHang_HoiSo}
      />
    </Spin>
  );
}
